/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { MouseEventHandler, useCallback } from "react";

import { AnalyticEventProps } from "@components/types";

export const emitEvent = (analyticsEvent?: AnalyticEventProps): void => {
	if (!analyticsEvent) {
		console.error("Failed to send analytic event analyticsEvent is invalid");
		return;
	}

	if (typeof _epicTracking !== "undefined" && _epicTracking && typeof _epicTracking.trackEvent === "function") {
		try {
			_epicTracking.trackEvent("Interaction", {
				...analyticsEvent,
				eventValue: JSON.stringify(analyticsEvent.eventValue),
			});
			console.debug("[epic-tracking] emitted event", analyticsEvent.eventAction, analyticsEvent);
		} catch (e) {
			console.error("Failed to send analytic event", e);
		}
	} else {
		console.warn("Failed to send analytic event _epicTracking is unavailable");
	}
};

export const useEmitEvent = (analyticsEvent?: AnalyticEventProps): (() => void) => {
	return useCallback(() => {
		emitEvent(analyticsEvent);
	}, [analyticsEvent]);
};

export const useEmitEventOnClick = (
	analyticsEvent?: AnalyticEventProps,
): MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> => {
	const onClick: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> = useCallback(
		(clickEvent) => {
			emitEvent({
				eventCategory: analyticsEvent?.eventCategory || "button",
				interactionType: analyticsEvent?.interactionType || "click",
				eventAction: analyticsEvent?.eventAction || "navigation",
				eventLabel: analyticsEvent?.eventLabel || "",
				eventValue: {
					...(analyticsEvent?.eventValue || {}),
					component: analyticsEvent?.eventValue?.component || "",
					clientX: clickEvent.clientX,
					clientY: clickEvent.clientY,
					pageX: clickEvent.pageX,
					pageY: clickEvent.pageY,
				},
			});
		},
		[analyticsEvent],
	);
	return onClick;
};
